import { CountriesPicker } from "../../../arbiter-components/select-dropdown/countries-picker";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { Text } from "../../../text";

export function ShippingCountriesField({
  countryCodes,
  setCountryCodes,
}: {
  countryCodes: string[];
  setCountryCodes: (codes: string[]) => void;
}) {
  return (
    <LabeledInput
      label={
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Shipping destination countries (optional)
        </Text>
      }
      size={LabelSize.EXTRA_SMALL}
    >
      <CountriesPicker
        countryCodes={countryCodes}
        setCountryCodes={setCountryCodes}
      />
    </LabeledInput>
  );
}
